import { Component } from '@theme/component';

/**
 * A custom element that lazy-loads product recommendations from Shopify's
 * recommendations endpoint and swaps them into the DOM once fetched.
 */
class ProductRecommendations extends Component {
  connectedCallback() {
    super.connectedCallback?.();
    this.#fetchRecommendations();
  }

  #fetchRecommendations() {
    const url = this.dataset.url;
    const sectionId = this.dataset.sectionId;
    const alreadyPerformed = this.dataset.recommendationsPerformed === 'true';

    if (!url || !sectionId || alreadyPerformed) return;

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to fetch recommendations: ${response.status}`);
        return response.text();
      })
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const newSection = html.querySelector('product-recommendations');
        if (newSection) {
          this.innerHTML = newSection.innerHTML;
          if (newSection.hasAttribute('data-recommendations-performed')) {
            this.setAttribute(
              'data-recommendations-performed',
              newSection.getAttribute('data-recommendations-performed')
            );
          }
        }
      })
      .catch((error) => {
        console.error('Product recommendations failed to load:', error);
      });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
